import { render, staticRenderFns } from "./CopyNFTModal.vue?vue&type=template&id=4b2628a0&scoped=true&"
import script from "./CopyNFTModal.vue?vue&type=script&lang=js&"
export * from "./CopyNFTModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyNFTModal.vue?vue&type=style&index=0&id=4b2628a0&scoped=true&lang=css&"
import style1 from "./CopyNFTModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2628a0",
  null
  
)

export default component.exports